import VendorHomeContainer from '@components/containers/vendorHome';
import VendorLayout from '@layouts/VendorLayout';
import { type FC } from 'react';

const VendorHome: FC = () => (
    <VendorLayout>
        <VendorHomeContainer />
    </VendorLayout>
);

export default VendorHome;
